import { FC } from 'react';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import LandscapeProjectsEditProjectsGeneralInformationTemplate from '../../../templates/LandscapeProjectsEditProjectsGeneralInformationTemplate';
import { Button, Label } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';

interface LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplateProps {}

const LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplate: FC<
  LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplateProps
> = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const OnAddGalleryTile = () => {
    navigate(`/landscapes/edit/${id}/about/landscape/add`);
  };

  return (
    <>
      <BaseTemplate>
        <Container>
          <LandscapeEditProjectsAddProjectTemplate>
            <LandscapeProjectsEditProjectsGeneralInformationTemplate>
              <div>
                <Label
                  content="These blocks will be added to the general page of a project"
                  size="heading-md"
                />
                <Button variant="dark" onClick={OnAddGalleryTile}>
                  Add Gallery Tile
                </Button>
              </div>
            </LandscapeProjectsEditProjectsGeneralInformationTemplate>
          </LandscapeEditProjectsAddProjectTemplate>
        </Container>
      </BaseTemplate>
    </>
  );
};

export default LandscapeProjectsAddProjectsGeneralInformationLeadPartnersTemplate;
